import Repository from './Repository';

const resource = 'auth';

export default {
    login(payload)      {return Repository.post(`${resource}/login`, payload);},
    register(payload)   {return Repository.post(`${resource}/register`, payload);},
    restore(payload)    {return Repository.post(`${resource}/restore`, payload);},
    checkRestoreToken(payload){return Repository.post(`${resource}/restore/check`, payload);},
    newPassword(payload){return Repository.post(`${resource}/new/password`, payload);},
    loginAdmin(payload) {return Repository.post(`${resource}/login/admin`, payload);},
    me()                {return Repository.get(`${resource}/me`);},
    meUpdate(payload)   {return Repository.put(`${resource}/me/update`, payload);},
}